import React from "react";
import ReactDOM from "react-dom/client";
import PlayerExperience from "../app/player-experience";
import "../app/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PlayerExperience />
  </React.StrictMode>,
);
